import { orchestrator } from 'satcheljs';
import setSelectedLabel from '../actions/clp/setSelectedCLPLabel';
import internalSetSelectedCLPLabel from '../actions/clp/internalSetSelectedCLPLabel';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { LabelApplyMethod } from 'owa-mail-protection-types/lib/schema/clp/CLPViewState';
const CLP_LABEL_INFOBAR_MESSAGE_ID = 'CLPLabel';

orchestrator(setSelectedLabel, actionMessage => {
    let { infoBarViewState, clpViewState, labelToSet } = actionMessage;
    const { infoBarIds } = infoBarViewState;
    if (clpViewState.selectedCLPLabel && labelToSet.id == clpViewState.selectedCLPLabel.id) {
        // When selected label gets clicked again. We remove the current label
        // by setting the selectedCLPLabel in clpViewState to null;
        internalSetSelectedCLPLabel(clpViewState, null, LabelApplyMethod.Default);
        if (infoBarIds.indexOf(CLP_LABEL_INFOBAR_MESSAGE_ID) >= 0) {
            removeInfoBarMessage(infoBarViewState, CLP_LABEL_INFOBAR_MESSAGE_ID);
        }
    } else if (labelToSet.isDefault) {
        internalSetSelectedCLPLabel(clpViewState, labelToSet, LabelApplyMethod.Default);
        if (infoBarIds.indexOf(CLP_LABEL_INFOBAR_MESSAGE_ID) >= 0) {
            removeInfoBarMessage(infoBarViewState, CLP_LABEL_INFOBAR_MESSAGE_ID);
        }
    } else {
        internalSetSelectedCLPLabel(clpViewState, labelToSet, LabelApplyMethod.Manual);
        if (infoBarIds.indexOf(CLP_LABEL_INFOBAR_MESSAGE_ID) < 0) {
            addInfoBarMessage(infoBarViewState, CLP_LABEL_INFOBAR_MESSAGE_ID);
        }
    }
});
